export default __webpack_public_path__ + "static/media/Heaven's Buchae.7a18e33e.jpg";